import { EvidenceGenerator } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import React from 'react'
import { Grid, GridColumn, GridRow } from 'src/components/Reusable/Grid'
import { ReceptorLogo } from 'src/components/async/model/receptor'
import { CUSTOM_RECEPTOR_ID } from 'src/Utils/Receptors/receptors.constants'
import { formatEvidenceCaption } from 'src/Utils/helpers/string.helpers'

export const EvidenceDisplayName = (
  evidenceId: string,
  receptorModelId: string,
): string => {
  if (receptorModelId === CUSTOM_RECEPTOR_ID) {
    return `Custom Receptor: ${evidenceId}`
  }
  return formatEvidenceCaption(evidenceId, true) as string
}

export const EvidenceGeneratorGrid = ({
  evidenceGenerators,
}: {
  evidenceGenerators: EvidenceGenerator[]
}): JSX.Element => {
  return (
    <Grid gridTemplateColumns="min-content 1fr">
      {evidenceGenerators.map((p) => (
        <GridRow key={p.getId()}>
          <GridColumn>
            <ReceptorLogo
              receptorModelId={p.getReceptorModelId()}
              width={'24px'}
              height={'24px'}
            />
          </GridColumn>
          <GridColumn>
            {EvidenceDisplayName(p.getEvidenceId(), p.getReceptorModelId())}
          </GridColumn>
        </GridRow>
      ))}
    </Grid>
  )
}
